export const namespace = true;

export const state = {
    isSearchExpanded: false,
};

export const getters = {
    isSearchExpanded: state => state.isSearchExpanded,
};

export const mutations = {
    /**
     * Mutate the  state `isSearchExpanded` with an updated boolean.
     *
     * @param  {Object} state            The Vuex state container.
     * @param  {boolean} isSearchExpanded  The boolean stating whether or not we are in active hours.
     */
    set: (state, { isSearchExpanded }) => {
        state.isSearchExpanded = isSearchExpanded;
    },
};

export const actions = {
    /**
     * The dispatchable action to show the navigation bar items when the tablet search
     * form is closed.
     *
     * @param  {Function} options.commit   The Vuex state commit function.
     */
    expand: ({ commit }) => {
        commit('set', {
            isSearchExpanded: true,
        });
    },

    /**
     * The dispatchable action to hide the navigation bar items when the tablet search
     * form is expanded.
     *
     * @param  {Function} options.commit   The Vuex state commit function.
     */
    close: ({ commit }) => {
        commit('set', {
            isSearchExpanded: false,
        });
    },
};
